import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import ConceptsModalBasicForm from '@/modules/configurationModule/detail/local-accounting/non-billable/concepts/components/concepts-modal-basic-form/concepts-modal-basic-form.vue'
import ConceptsModalBreakdowns from '@/modules/configurationModule/detail/local-accounting/non-billable/concepts/components/concepts-modal-breakdowns/concepts-modal-breakdowns.vue'

@Component({
    components: {
        ConceptsModalBasicForm,
        ConceptsModalBreakdowns
    }
})
export default class ConceptsModal extends Vue {
    @Ref() readonly conceptsModal!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.conceptsModal.show()
    }

    hide() {
        this.conceptsModal.hide()
    }
}
